import { useState } from "react";

const cases = [
  {
    id: 1,
    title: "주방 집중 청소",
    location: "서울 강남구 아파트",
    before: "https://readdy.ai/api/search-image?query=dirty%20messy%20Korean%20apartment%20kitchen%20before%20cleaning%2C%20greasy%20stove%20hood%2C%20stained%20tiles%2C%20cluttered%20countertops%2C%20old%20grease%20buildup%2C%20dim%20lighting&width=600&height=450&seq=ba001&orientation=landscape",
    after: "https://readdy.ai/api/search-image?query=spotlessly%20clean%20Korean%20apartment%20kitchen%20after%20professional%20cleaning%2C%20shining%20stove%20hood%2C%20pristine%20white%20tiles%2C%20organized%20countertops%2C%20bright%20lighting%2C%20like%20new%20condition&width=600&height=450&seq=ba002&orientation=landscape",
  },
  {
    id: 2,
    title: "욕실 곰팡이 제거",
    location: "경기 성남시 빌라",
    before: "https://readdy.ai/api/search-image?query=dirty%20bathroom%20with%20mold%20and%20mildew%20on%20tiles%20and%20grout%2C%20stained%20toilet%20and%20sink%2C%20soap%20scum%20on%20shower%20glass%2C%20neglected%20Korean%20bathroom%20before%20cleaning&width=600&height=450&seq=ba003&orientation=landscape",
    after: "https://readdy.ai/api/search-image?query=sparkling%20clean%20Korean%20bathroom%20after%20professional%20deep%20cleaning%2C%20white%20pristine%20tiles%2C%20clean%20grout%20lines%2C%20shining%20toilet%20and%20sink%2C%20crystal%20clear%20shower%20glass&width=600&height=450&seq=ba004&orientation=landscape",
  },
  {
    id: 3,
    title: "입주 전 전체 청소",
    location: "인천 연수구 신축 아파트",
    before: "https://readdy.ai/api/search-image?query=empty%20Korean%20apartment%20before%20move-in%20cleaning%2C%20construction%20dust%20on%20floors%2C%20dirty%20windows%2C%20unclean%20surfaces%2C%20needs%20thorough%20cleaning&width=600&height=450&seq=ba005&orientation=landscape",
    after: "https://readdy.ai/api/search-image?query=perfectly%20clean%20empty%20Korean%20apartment%20ready%20for%20move-in%2C%20polished%20floors%2C%20crystal%20clear%20windows%2C%20dust-free%20surfaces%2C%20bright%20and%20welcoming%20space&width=600&height=450&seq=ba006&orientation=landscape",
  },
];

export default function BeforeAfterSection() {
  const [activeCase, setActiveCase] = useState(0);
  const [showAfter, setShowAfter] = useState(false);

  return (
    <section className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl mx-auto">
          <div>
            <div className="inline-flex items-center gap-2 bg-rose-100 text-rose-700 text-sm font-medium px-4 py-2 rounded-full mb-6">
              <i className="ri-camera-line"></i>
              <span>실제 작업 사례</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6 leading-tight">
              눈에 띄는 변화,<br />
              <span className="text-amber-500">확실한 결과</span>
            </h2>
            <p className="text-gray-500 text-lg leading-relaxed mb-8">
              전문 장비와 친환경 세제를 사용하여 일반 청소로는 해결하기 어려운 
              묵은 때와 오염을 제거합니다.
            </p>

            <div className="grid grid-cols-3 gap-4 mb-8">
              {[
                { num: "5,000+", label: "누적 작업" },
                { num: "고객 만족", label: "재방문율" },
                { num: "4.9", label: "평균 평점" },
              ].map((s) => (
                <div key={s.label} className="bg-white rounded-2xl p-4 text-center border border-gray-100">
                  <div className="text-2xl font-bold text-amber-500">{s.num}</div>
                  <div className="text-xs text-gray-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col gap-3">
              {cases.map((c, i) => (
                <button
                  key={c.id}
                  onClick={() => { setActiveCase(i); setShowAfter(false); }}
                  className={`flex items-center gap-3 p-4 rounded-xl text-left transition-all cursor-pointer ${
                    activeCase === i
                      ? "bg-amber-500 text-white"
                      : "bg-white border border-gray-100 hover:border-amber-200"
                  }`}
                >
                  <div className={`w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 ${
                    activeCase === i ? "bg-white/20" : "bg-amber-100"
                  }`}>
                    <i className={`ri-image-line text-sm ${activeCase === i ? "text-white" : "text-amber-600"}`}></i>
                  </div>
                  <div>
                    <div className={`font-semibold text-sm ${activeCase === i ? "text-white" : "text-gray-900"}`}>
                      {c.title}
                    </div>
                    <div className={`text-xs ${activeCase === i ? "text-white/70" : "text-gray-400"}`}>
                      {c.location}
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
